import { isProd } from "@web-app/utils/env.utils";

/** GLP-1 Consultation visit type in Healthie (`filter_by_appointment_type_id`). */
export const GLP1_CONSULTATION_APPOINTMENT_TYPE_ID = isProd ? '517951' : '695549';

/** GLP-1 Follow-Up visit type in Healthie. */
export const GLP1_FOLLOW_UP_APPOINTMENT_TYPE_ID = isProd ? '523879' : '669523';
